import omit from 'lodash-es/omit';
var getLastMessage = function (chatThread) {
    var normalizedChatThread = omit(chatThread, ['__EMPTY_ID__']);
    // Pick the last saved message
    var lastSavedMessage = normalizedChatThread[Object.keys(normalizedChatThread)[0]];
    for (var _i = 0, _a = Object.keys(normalizedChatThread); _i < _a.length; _i++) {
        var key = _a[_i];
        var chatThreadMessage = normalizedChatThread[key];
        if (chatThreadMessage.timestamp > lastSavedMessage.timestamp) {
            lastSavedMessage = chatThreadMessage;
        }
    }
    return lastSavedMessage;
};
var getFinalLastMessage = function (threadMessages) {
    var filteredThreadArray = threadMessages.filter(function (value) { if (value === null || value === void 0 ? void 0 : value.timestamp)
        return value; });
    if (filteredThreadArray.length < 1)
        return;
    var lastMessage = filteredThreadArray[0];
    for (var index = 0; index < filteredThreadArray.length; index++) {
        var threadMsg = filteredThreadArray[index];
        if ((threadMsg === null || threadMsg === void 0 ? void 0 : threadMsg.timestamp) > (lastMessage === null || lastMessage === void 0 ? void 0 : lastMessage.timestamp)) {
            lastMessage = threadMsg;
        }
    }
    return lastMessage;
};
export var getMeta = function (state) {
    var _a;
    var pmaSaveThreadLastMessage = Object.keys(state.chat.pmaSaveMessage).length > 0 ?
        getLastMessage(state.chat.pmaSaveMessage) : {};
    var pmaCreateThreadLastMessage = Object.keys(state.chat.pmaCreateThread).length > 0 ?
        getLastMessage(state.chat.pmaCreateThread) : {};
    var pmaReadThreadLastMessage = Object.keys(state.chat.pmaReadThread).length > 0 ?
        getLastMessage(state.chat.pmaReadThread) : {};
    var finalLastMessage = getFinalLastMessage([pmaSaveThreadLastMessage, pmaCreateThreadLastMessage, pmaReadThreadLastMessage]);
    return ((_a = finalLastMessage === null || finalLastMessage === void 0 ? void 0 : finalLastMessage.payload) === null || _a === void 0 ? void 0 : _a.__meta__) || {};
};
